import { render, staticRenderFns } from "./a-f-info-list.vue?vue&type=template&id=6a444ea2&scoped=true"
import script from "./a-f-info-list.vue?vue&type=script&lang=js"
export * from "./a-f-info-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a444ea2",
  null
  
)

export default component.exports